<template>
  <div>
    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por erro ou detalhe">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query"
                      :amount-changed="updateNumberOfBadges"
                      :filters="[filterAccount, filterCnpj, filterDfe, filterType]"
                      @clearBadge="find()"
                      @clearAllBadges="find()"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-6">
          <label for="nsu-manager-account-id">Contas</label>
          <Select2 :options="filterAccount"
                   v-model="query.accountId"
                   id="nsu-manager-account-id"
                   title-load="Carregando contas..."
                   @input="changeAccount"
          />
        </div>

        <div class="col-md-6">
          <label for="nsu-manager-cnpj">CNPJ</label>
          <Select2 v-if="hasOptionCnpj"
                   :options="filterCnpj"
                   v-model="query.cnpj"
                   id="nsu-manager-cnpj"
                   title-load="Carregando cnpj..."
          />
          <Select2 v-else :value="{}" :options="null" title-load="Selecione uma conta..."/>
        </div>
      </div>
      
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="nsu-manager-type">Tipo</label>
          <Select2 id="nsu-manager-type" v-model="query.type" :options="filterType"/>
        </div>
        
        <div class="col-md-4">
          <label for="nsu-manager-active">DFe ativo</label>
          <select v-model="query.active" class="form-control" id="nsu-manager-active">
            <option v-for="option in filterDfe.table" :value="option.value" :key="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
  
        <div class="col-md-4">
          <label for="nsu-manager-order-by">Ordenar por</label>
          <select v-model="orderBy" id="nsu-manager-order-by" class="form-control">
            <option value="diff">Diferença</option>
            <option value="consulted_at">Consultado em</option>
            <option value="updated_at">Atualizado em</option>
            <option value="created_at">Criado em</option>
          </select>
        </div>
      </div>
    </template>
    <hr>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
            <tr>
              <th>ID</th>
              <th>Conta</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th>Consultado em</th>
              <th>Empresa</th>
              <th>Tipo</th>
              <th>Próximo NSU</th>
              <th>Máximo NSU</th>
              <th>Diferença</th>
              <th>Erro/Detalhe</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="nsuManager in nsuManagers" :key="nsuManager.id">
              <td :class="buildStatusClass(nsuManager)">
                {{ nsuManager.id }}
              </td>
              <td>{{ nameAccount(nsuManager) }}</td>
              <td>{{ nsuManager.createdAt | datetime }}</td>
              <td>{{ nsuManager.updatedAt | datetime }}</td>
              <td>{{ nsuManager.consultedAt | datetime }}</td>
              <td>{{ nameCompany(nsuManager) }}</td>
              <td>{{ nsuManager.nsuType }}</td>
              <td>{{ nsuManager.nextNumberNsu }}</td>
              <td>{{ nsuManager.maxNsu }}</td>
              <td>{{ nsuManager.diff }}</td>
              <td>{{ nsuManager.message }}</td>
              <td>
                <button @click="showDetail(nsuManager)" class="btn btn-outline">
                  Detalhes
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <Modal v-if="currentNsuManager" v-model="showModal" width="xl">
      <div slot="header">
        <p>
          <span>Empresa: </span>
          <strong>{{ nameCompany(currentNsuManager) }}</strong>
          <span> - </span>
          <span>Conta: </span>
          <strong>{{ nameAccount(currentNsuManager) }}</strong>
        </p>
      </div>
  
      <div class="row app">
        <div class="col-md-2">
          <p><strong>ID: </strong>{{ currentNsuManager.id }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Tipo: </strong>{{ currentNsuManager.nsuType }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>CNPJ: </strong>{{ currentNsuManager.cnpj }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Próximo NSU: </strong>{{ currentNsuManager.nextNumberNsu }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Último NSU:</strong> {{ currentNsuManager.maxNsu }}</p>
        </div>
        <div class="col-md-2">
          <p><strong>Diferença:</strong> {{ currentNsuManager.diff }}</p>
        </div>
        <div class="col-md-4">
          <p><strong>Consultado em:</strong> {{ currentNsuManager.consultedAt | datetime }}</p>
        </div>
        <div class="col-md-8">
          <p><strong>Error/Detalhe:</strong> {{ currentNsuManager.message }}</p>
        </div>
      </div>
  
      <hr>
      <div class="row">
        <div class="col-md-12">
          <div>
            <div class="ibox" v-for="event in events" :key="event.number">
              <div class="ibox-title" @click="event.visible = !event.visible" style="cursor: pointer">
                <strong>Consulta {{ event.number }} - Quantidade: {{ event.values.length }}</strong>
              </div>
      
              <div class="ibox-content" v-show="event.visible">
                <table class="nsu-events table table-borderless table-align table-h51">
                  <thead>
                  <tr>
                    <th>Início</th>
                    <th>NSU</th>
                    <th>Fim</th>
                    <th>Próximo NSU</th>
                    <th>NSUs retornados</th>
                    <th>Tempo de execução (segundos)</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="([start, nsu, end, nextNsu, diff, diffNsu]) in event.values" :key="start">
                    <td class="py-0">{{ start | datetime}}</td>
                    <td class="py-0">{{ nsu }}</td>
                    <td class="py-0">{{ end  | datetime }}</td>
                    <td class="py-0">{{ nextNsu }}</td>
                    <td class="py-0">{{ diff }}</td>
                    <td class="py-0">{{ diffNsu }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <hr>
      <hr>
      <div class="nsuManager-detail mt-3">
        <VueJsonPretty :data="currentNsuManager"
                       :deep="3"
                       :showLength="true"
                       :showLine="true"/>
      </div>

    </Modal>

  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import Select2 from '@/components/shares/Select2'
  import VueJsonPretty from 'vue-json-pretty'
  import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'

  import 'vue-json-pretty/lib/styles.css'

  export default {
    components: { BadgeFilters, ChevronDownIcon, Modal, Pagination, SearchIcon, Select2, VueJsonPretty },
    computed: {
      hasOptionCnpj() {
        return this.filterCnpj && this.filterCnpj.table.length > 0
      },
      nsuManagers() {
        return this.getModels || []
      }
    },
    created() {
      this.addOrderBy('diff')
      this.addOrderBy('updatedAt')
      this.defaultModelSetting.updateQueryURL = true
      this.$set(this.query, 'active', true)
  
      this.openLoad()
      this.findAccountWithCnpjs(() => {
        this.asyncTemplateSelect({
          before: () => this.updateFilterCnpjs(this.query.accountId),
          byURL: true,
          pagination: true,
        })
      })
    },
    data() {
      return {
        accounts: [],
        currentNsuManager: null,
        events: null,
        filterAccount: null,
        filterCnpj: null,
        filterDfe: new Filter({
          key: 'active',
          label: 'DFe ativo',
          table: [
            ['Todos', ''],
            ['Sim', 'true'],
            ['Não', 'false'],
          ],
        }),
        filterType: new Filter({
          key: 'type',
          label: 'Tipo',
          table: ['', 'NFe', 'CTe'],
        }),
        modelPathPrefix: 'admin',
        nameModel: 'NsuManager',
        orderBy: 'diff',
        showModal: false,
      }
    },
    methods: {
      buildFilterAccount(accounts) {
        this.accounts = accounts
        this.filterAccount = new Filter({
          key: 'accountId',
          label: 'Conta',
          table: this.accounts.map(a => [`${a.id} - ${a.name}`, `${a.id}`])
        })
      },
      buildStatusClass(nsuManager) {
        if (nsuManager.diff === 0)
          return 'marker-green'
        else if (nsuManager.diff > 500)
          return 'marker-red'
        else
          return 'marker-yellow'
      },
      changeAccount(accountIds) {
        this.updateFilterCnpjs(accountIds)
      },
      find() {
        this.asyncTemplateSelect()
      },
      findAccountWithCnpjs(callback) {
        const key = 'accounts_with_cnpjs'
        const accounts = this.$ls.get(key)
        
        if (accounts) {
          this.buildFilterAccount(accounts)
          callback()
        } else {
          this.axios.get('/admin/nsu_managers/accounts_with_cnpjs')
            .then(response => {
              this.$ls.set(key, response.data, { minutes: 10 })
              this.buildFilterAccount(response.data)
            })
            .then(() => callback())
        }
      },
      nameAccount(nsuManager) {
        const account = this.accounts.find(a => a.id === nsuManager.accountId)
        return account.name
      },
      nameCompany(nsuManager) {
        const account = this.accounts.find(a => a.id === nsuManager.accountId)
        const company = account.companies.find(c => c.cnpj === nsuManager.cnpj)
        return company && `${company.name} - ${company.cnpj}` || nsuManager.cnpj
      },
      showDetail(nsuManager) {
        this.currentNsuManager = nsuManager
        this.showModal = true
      },
      updateEvents() {
        if (!this.currentNsuManager.history)
          return this.events = []
        
        this.events = Object.entries(this.currentNsuManager.history)
          .map(([key, values]) => [key, values.reverse()])
          .map(([key, values]) => {
            
            values = values.map(value => {
              const [start, nsu, end, nextNsu] = value
              
              if (nsu && end && nextNsu) {
                const diffNsu = parseInt(nextNsu) - parseInt(nsu)
                const diff = (new Date(end).getTime() - new Date(start).getTime()) / 1000
                return [start, nsu, end, nextNsu, diffNsu, diff]
              } else {
                return [start, nsu, end, nextNsu]
              }
            })
            
            return [key, values]
          })
          .map(([key, values]) => ({ number: key, values, visible: false }))
          .reverse()
      },
      updateFilterCnpjs(accountIds) {
        let table = []
        if (accountIds && accountIds.length > 0) {
          table = this.accounts.filter(a => accountIds.includes(`${a.id}`))
                                .map(a => a.companies)
                                .flat()
                                .map(c => [`${c.name} - ${c.cnpj}`, c.cnpj])
        }
            
        this.filterCnpj = new Filter({
          key: 'cnpj',
          label: 'cnpj',
          table: table
        })
      }
    },
    mixins: [ModelMapper],
    name: 'NsuManager',
    watch: {
      currentNsuManager() {
        this.updateEvents()
      },
      orderBy(value) {
        this.order = []
        if (value === 'diff') {
          this.addOrderBy('diff')
          this.addOrderBy('updatedAt')
        } else {
          this.addOrderBy(value)
        }
      },
    }
  }
</script>

<style scoped>

  .nsuManager-detail * {
    background: #051724;
    color: #FFF;
    padding: 16px;
    border-radius: 8px;
  }

  .rotate-90 {
    transform: rotate(180deg);
  }

  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }

  .icon-within {
    top: 5px;
  }
  
  .nsuManager-message::selection {
    background: #e74c3c;
  }
  
  .nsu-events td {
    height: 24px;
  }

</style>
